import isEmail from 'validator/lib/isEmail';
import { isNil } from 'lodash';
import moment from 'moment';

// CONSTANTS
import { DATE_FORMAT } from 'constants/formats.constants';

function _isNilOrEmptyString(val) {
  if (isNil(val)) {
    return true;
  }

  if (typeof val === 'string' && !val.length) {
    return true;
  }

  return false;
}

export function validateEmail(email) {
  // Field is empty. Use Required validator to validate non-empty.
  if (_isNilOrEmptyString(email)) {
    return [0, []];
  }

  if (!isEmail(email)) {
    return [2, [{ translationId: 'validators.email.emailIsNotValid' }]];
  }

  return [0, []];
}

export function validatePassword(password) {
  if (typeof password !== 'string') {
    return [2, []];
  }

  if (password.length < 8) {
    return [2, [{ translationId: 'validators.password.invalid.minimumLength' }]];
  }

  if (password.search(/\d/) === -1) {
    return [2, [{ translationId: 'validators.password.invalid.mustContainNumber' }]];
  }

  if (password.search(/[a-z]/) === -1 || password.search(/[A-Z]/) === -1) {
    return [
      2,
      [
        {
          translationId: 'validators.password.invalid.mustContainUpperAndLowerCase',
        },
      ],
    ];
  }

  return [0, []];
}

export const matchValueValidator = (base) => (comparator) => {
  if (String(comparator) !== base) {
    return [2, [{ translationId: 'validators.match.valuesMustMatch' }]];
  }

  return [0, []];
};

export function validateYearMonthDayDate(dateString) {
  if (!isNil(dateString)) {
    const parsedDate = moment(String(dateString), DATE_FORMAT, true);

    if (!parsedDate.isValid()) {
      return [2, [{ translationId: 'validators.date.invalidDate' }]];
    }
  }

  return [0, []];
}

export function validateISODate(dateString) {
  if (!isNil(dateString)) {
    const parsedDate = moment(String(dateString), moment.ISO_8601, true);

    if (!parsedDate.isValid()) {
      return [2, [{ translationId: 'validators.date.invalidDate' }]];
    }
  }

  return [0, []];
}

export function validatePercentage(percentage: number | string | null) {
  if (!isNil(percentage)) {
    const parsedPercentage = Number(percentage);

    if (isNaN(parsedPercentage)) {
      return [2, [{ translationId: 'validators.percentage.invalid' }]];
    }

    if (parsedPercentage < 0 || parsedPercentage > 100) {
      return [2, [{ translationId: 'validators.percentage.outOfBounds' }]];
    }
  }

  return [0, []];
}
